import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImpersonationFacade } from '../../../../Facades/impersonation.facade';

@Component({
  selector: 'av-impersonation-notch',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './impersonation-notch.component.html',
  styleUrls: ['./impersonation-notch.component.scss']
})
export class ImpersonationNotchComponent {
  readonly facade = inject(ImpersonationFacade);
}
